module.exports = __webpack_public_path__ + "a49e770fac862667d5ddf2ae0d05daa4.pdf";